export enum VideoStreamType {
    Main,
    Sub
}
